/**
 *-------------------------------------------
 * apis in common, routes.jsx, login page, register page, verify page...
 *-------------------------------------------
 */

import { postData } from '../../request'

export function getCountryList(body) {
    return postData('/api/getCountryList_V2/', body)
}

export function login(body) {
    return postData('/api/login/', body, { cancelToken: null })
}

export function register(body) {
    return postData('/api/userRegister/', body)
}

export function printLog(body) {
    return postData('/api/getTabName/', body, { cancelToken: null })
}

export function loginOpenAM(body) {
    return postData('/api/loginOpenAM/', body, { cancelToken: null })
}

export function redirectIAM(body) {
    return postData('api/redirectIAM/', body)
}

export function verifyChangeEmail(body) {
    return postData('/api/verifyChangEmail/', body)
}

export function getChangeEmail(body) {
    return postData('/api/getChangeEmail/', body)
}

export function logout(body) {
    return postData('/api/logout/', body)
}

export function getUsersMaster(body) {
    return postData('/api/getUsersMaster/', body)
}

export function registerUser(body) {
    return postData('/api/signUp/', body)
}
